<template>
  <div class="cover" :class="{ 'cover--disabled': disabled }">
    <h1>{{ about.competition }}</h1>
    <small>{{ about.location }}, {{ about.date }}</small>
    <p>Wyniki i informacje już wkrótce!</p>

    <img src="@/assets/logo.svg" class="logo" />

    <!-- <a
      href="https://heseya.com/pl/organizacja-zawodow-luczniczych"
      class="about-us"
      target="_blank"
    >
      <font-awesome-icon icon="info-circle" />
      <span>O systemie</span>
    </a> -->
  </div>
</template>

<script>
export default {
  name: 'cover',
  props: {
    disabled: Boolean,
  },
  computed: {
    about() {
      return this.$store.state.cache.about
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
@import '@/scss/_mixins.scss';

.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% + 20px);
  z-index: 10000;
  background-color: $bg;
  padding-top: 20vh;
  transition: 0.3s;
  opacity: 1;
  visibility: visible;

  &--disabled {
    top: -20px;
    opacity: 0;
    visibility: hidden;
  }

  h1 {
    color: $primary;
    font-size: 2.8em;
    margin-bottom: 0;
  }

  p {
    margin-top: 24px;
    font-style: italic;
  }

  .about-us {
    position: absolute;
    top: 8px;
    right: 8px;
    padding: 16px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    color: $primary;
    text-decoration: none;
    transition: 0.3s;

    &:hover {
      color: $orange;
    }

    svg {
      margin-right: 8px;
    }
  }

  .logo {
    position: absolute;
    top: 8px;
    left: 8px;
    width: 48px;
  }
}
</style>
